var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"show-links":false}},[_c('Jumbotron',{attrs:{"authorizationLink":{},"errorPage":"","title":_vm.$t('generating')}}),_c('Cards'),_c('JumbotronSmall',{attrs:{"authorizationLink":{},"errorPage":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }